import React from 'react';

const ProductSyncModal = ({ 
  modalId = 'productSyncModal', 
  isLoading = false, 
  products = [], 
  syncStats = null,
  error = null,
  categoryName = '' 
}) => {
  return (
    <div className="modal fade" id={modalId} tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog modal-xl" style={{ maxWidth: '1400px' }}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              Synchronisation des Produits
              {categoryName && <span className="text-muted ms-2">- {categoryName}</span>}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            {isLoading && (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                  <span className="visually-hidden">Chargement...</span>
                </div>
                <p className="mt-3 text-muted">Synchronisation des produits en cours...</p>
              </div>
            )}

            {error && !isLoading && (
              <div className="alert alert-danger" role="alert">
                <i className="fas fa-exclamation-triangle me-2"></i>
                {error}
              </div>
            )}

            {!isLoading && !error && syncStats && (
              <div>
                <div className="row g-3 mb-4">
                  <div className="col-md-3">
                    <div className="card bg-primary text-white">
                      <div className="card-body text-center">
                        <h3 className="mb-1">{syncStats.totalProducts || 0}</h3>
                        <small>Total Produits</small>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="card bg-success text-white">
                      <div className="card-body text-center">
                        <h3 className="mb-1">{syncStats.updated || 0}</h3>
                        <small>Mis à jour</small>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="card bg-warning text-white">
                      <div className="card-body text-center">
                        <h3 className="mb-1">{(syncStats.conflicts || []).length}</h3>
                        <small>Conflits</small>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="card bg-secondary text-white">
                      <div className="card-body text-center">
                        <h3 className="mb-1">{(syncStats.notFound || []).length}</h3>
                        <small>Non trouvés</small>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Conflicts Section */}
                {syncStats.conflicts && syncStats.conflicts.length > 0 && (
                  <div className="mb-4">
                    <h6 className="mb-3">
                      <i className="fas fa-exclamation-triangle text-warning me-2"></i>
                      Produits avec conflits ({syncStats.conflicts.length})
                    </h6>
                    <div className="table-responsive">
                      <table className="table table-sm table-striped">
                        <thead>
                          <tr>
                            <th>Nom du produit</th>
                            <th>Glovo ID</th>
                            <th>Nombre de correspondances</th>
                          </tr>
                        </thead>
                        <tbody>
                          {syncStats.conflicts.map((conflict, index) => (
                            <tr key={index}>
                              <td>{conflict.productName}</td>
                              <td><code>{conflict.glovoId}</code></td>
                              <td>
                                <span className="badge bg-warning">
                                  {conflict.matchCount} correspondances
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {/* Not Found Section */}
                {syncStats.notFound && syncStats.notFound.length > 0 && (
                  <div className="mb-4">
                    <h6 className="mb-3">
                      <i className="fas fa-search text-secondary me-2"></i>
                      Produits non trouvés dans la base locale ({syncStats.notFound.length})
                    </h6>
                    <div className="table-responsive">
                      <table className="table table-sm table-striped">
                        <thead>
                          <tr>
                            <th>Nom du produit</th>
                            <th>Glovo ID</th>
                          </tr>
                        </thead>
                        <tbody>
                          {syncStats.notFound.slice(0, 20).map((product, index) => (
                            <tr key={index}>
                              <td>{product.productName}</td>
                              <td><code>{product.glovoId}</code></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {syncStats.notFound.length > 20 && (
                        <p className="text-muted small">
                          ... et {syncStats.notFound.length - 20} autres produits non trouvés
                        </p>
                      )}
                    </div>
                  </div>
                )}

                {/* Products List */}
                {products && products.length > 0 && (
                  <div>
                    <h6 className="mb-3">Produits de la catégorie</h6>
                    <div className="row g-3">
                      {products.slice(0, 50).map((product, index) => (
                        <div key={product.id || index} className="col-md-3 col-sm-4 col-6">
                          <div className="card h-100">
                            {product.imageUrl && (
                              <img 
                                src={product.imageUrl} 
                                className="card-img-top" 
                                alt={product.name}
                                style={{ height: '150px', objectFit: 'cover' }}
                                onError={(e) => { e.target.style.display = 'none'; }}
                              />
                            )}
                            <div className="card-body p-2">
                              <p className="small mb-1 text-truncate" title={product.name}>
                                <strong>{product.name}</strong>
                              </p>
                              <p className="small mb-0 text-muted">
                                {product.price ? `${(product.price / 100).toFixed(2)} MAD` : 'N/A'}
                              </p>
                              <p className="small mb-0">
                                {product.available ? (
                                  <span className="badge bg-success">Disponible</span>
                                ) : (
                                  <span className="badge bg-secondary">Indisponible</span>
                                )}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    {products.length > 50 && (
                      <p className="text-muted small mt-3">
                        Affichage de 50 produits sur {products.length}
                      </p>
                    )}
                  </div>
                )}

                {(!products || products.length === 0) && syncStats.updated === 0 && (
                  <div className="text-center py-5">
                    <i className="fas fa-inbox fa-3x text-muted mb-3"></i>
                    <p className="text-muted">Aucun produit à afficher</p>
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductSyncModal;
